<template>
  <div class="Home">
    <SideBar></SideBar>

    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>岗位模型分析</h3>
          <i class="selected"></i>
          <div class="swiperBox">
            <el-tabs stretch lazy v-model="activeName">
              <el-tab-pane label="开发类" name="0">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList0" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="系统运维类" name="1">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList1" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="系统集成与项目实施类" name="2">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList2" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="市场营销类" name="3">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList3" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="技术服务、技术支持类" name="4">
                <div class="engineer">
                  <div class="engineerClass" v-for="item in tabList4" :key="item.name">
                    <div class="engineerTitle">{{ item.name }}</div>
                    <div class="engineerText">
                      <p>{{ item.list.p0 }}</p>
                      <p>{{ item.list.p1 }}</p>
                      <p>{{ item.list.p2 }}</p>
                      <p>{{ item.list.p3 }}</p>
                      <p>{{ item.list.p4 }}</p>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Employment extends Vue {
// tab选中的栏
activeName= '0'
      // 开发类
      tabList0= [
        {
          name: 'ETL工程师',
          list: {
            p0:
              '1、精通ETL架构及流程，熟悉常用的ETL开发工具如Datastage,Congos,Kettle等；',
            p1: '2、熟悉主流数据库技术及操作；',
            p2: '3、熟练使用Linux系统，熟悉Java/Python等编程语言及基础算法等；',
            p3: '4、熟悉大数据平台及各组件应用场景。'
          }
        },
        {
          name: '大数据开发工程师',
          list: {
            p0: '1、熟悉Java/Python开发；',
            p1: '2、具备Linux操作环境能力，能编写Shell脚本；',
            p2: '3、熟悉MySQL、Oracle等主流数据库，熟练编写SQL语句；',
            p3: '4、精通Hadoop及其生态组件技术原理。'
          }
        },
        {
          name: '大数据挖掘工程师',
          list: {
            p0:
              '1、具备扎实的Python编程基础，熟悉常用的数据挖掘开源框架或工具，比如scikit-learn，Pandas，Numpy；',
            p1: '2、熟悉Linux操作，能写shell脚本；',
            p2: '3、熟悉常用SQL命令的使用，会使用SQL编写脚本；',
            p3: '4、精通Hadoop及生态相关技术；',
            p4: '5、 熟悉常用数据挖掘和机器学习算法的原理和实现。'
          }
        },
        {
          name: '大数据分析工程师',
          list: {
            p0: '1、熟悉Linux操作，能写Shell脚本；',
            p1: '2、Python编程，熟悉常用的数据挖掘开源框架或工具；',
            p2: '3、熟悉Hadoop生态组件基础原理和流程；',
            p3: '4、熟悉主流数据建模算法，数据ETL；',
            p4: '5、能够熟练使用常用SQL命令的使用，会使用SQL编写脚本。'
          }
        }
      ]
      // 系统运维类
      tabList1= [
        {
          name: '大数据运维工程师',
          list: {
            p0:
              '1、掌握Linux操作系统的配置，管理及优化，能够独立排查及解决操作系统层的各类问题，会使用Linux Shell/Python编写脚本；',
            p1:
              '2、掌握Hadoop生态组件工作原理，运行机制；具备大数据平台的监控以及调优，有独立分析问题和解决问题的能力；掌握大数据平台日志分析方法，并能利用日志进行系统故障排查和优化；',
            p2:
              '3、掌握数据库基础，熟练使用SQL语句、编写SQL脚本；熟练掌握ETL流程和操作；',
            p3: '4、掌握企业传统IP网络管理和配置。'
          }
        }
      ]
      // 系统集成与项目实施类
      tabList2= [
        {
          name: '大数据实施工程师',
          list: {
            p0: '1、理解Hadoop及其生态组件技术原理；',
            p1: '2、具备交换机配置相关知识；',
            p2: '3、具备Linux shell脚本/Python脚本编写能力；',
            p3: '4、熟悉主流数据库相关知识；',
            p4: '5、数据采集、ETL流程及相关操作。'
          }
        }
      ]
      // 市场营销类
      tabList3= [
        {
          name: '大数据客户经理',
          list: {
            p0: '1、理解Hadoop及其生态组件技术原理；',
            p1: '2、熟悉主流数据库相关知识；',
            p2: '3、熟悉数据挖掘等领域知识。'
          }
        }
      ]
      // 技术服务、技术支持类
      tabList4= [
        {
          name: '大数据售前技术支持工程师',
          list: {
            p0: '1、理解Hadoop及其生态组件技术原理；',
            p1: '2、熟悉主流数据库相关知识；',
            p2: '3、熟悉数据分析、数据挖掘等领域知识；',
            p3: '4、熟悉数据采集流程和方法；',
            p4: '5、熟悉脚本编写。'
          }
        }
      ]
}

</script>
<style lang="less" scoped>
/deep/.el-icon-arrow-right,
/deep/.el-icon-arrow-left {
  font-size: 30px;
  margin-top: 5px;
}
/deep/.el-icon-arrow-right::before,
/deep/.el-icon-arrow-left:before,
/deep/.el-tabs__item:hover,
/deep/.el-tabs__item.is-active {
  color: #dd0011;
}

/deep/.el-tabs__active-bar {
  background-color: #dd0011;
  // left: 50%;
  // width: 50px !important;
}
/deep/.el-tabs__item {
  font-size: 1.125rem;
}
.swiperBox {
  margin-top: 30px;
}
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
}
.conent {
  background-color: #f8f8f8;
  .conent_box {
    // height: 500px;
    padding: 2.8125rem 5rem 0;
    h3 {
      font-size: 1.75rem;
      text-align: center;
      color: #333;
    }
    .selected {
      display: block;
      width: 1.5625rem;
      height: 0.1875rem;
      background-color: #333333;
      margin: 0.625rem auto 0;
    }
    .classification {
      // border-bottom: 1px solid #ccc;
      display: flex;
      justify-content: space-around;
      padding: 3.125rem 0 0;
      // 选中时字体颜色显示图片
      .active {
        color: #dd0011;
        img {
          opacity: 1;
        }
      }
      p {
        cursor: pointer;
        font-size: 1.125rem;
        color: #333;
        font-weight: 500;
        position: relative;
        padding-bottom: 10px;
        img {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          z-index: 3333;
        }
      }
    }
    .engineer {
      padding: 2.25rem 6.25rem 4.375rem;
      .engineerClass {
        background-color: #fff;
        margin-bottom: 0.4375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .engineerTitle {
          width: 200px;
          padding: 10px;
          font-size: 1.125rem;
          color: #333;
          text-align: center;
        }
        .engineerText {
          flex: 1;
          padding: 0.625rem;
          border-left: 1px solid #ccc;
          font-size: 0.875rem;
          color: #666;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  // 岗位模型分析导航
  .conent {
    .conent_box {
      h3 {
        font-size: 18px;
      }
      padding: 0.625rem;
      .classification {
        align-content: center;
        flex-wrap: wrap;
        padding-top: 0.9375rem;
        p {
          font-size: 14px;
          padding: 0 10px;
        }
        .active {
          margin-bottom: 0.625rem;
        }
      }
      .engineer {
        padding: 0.625rem 0;
        .engineerClass {
          flex-direction: column;
          .engineerText {
            width: 100%;
            border-left: 0;
          }
        }
      }
    }
  }
  .conent .conent_box .classification p img {
    bottom: -10px;
  }
  .conent_box {
    padding-top: 20px !important;
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
}
</style>
